export default {
  gw: {
    news: {
      title: "กลยุทธ์และข่าวสาร",
      strategyTab: "คู่มือทางการ",
      announcementTab: "ประกาศ",
      prevPage: "หน้าก่อนหน้า",
      nextPage: "หน้าถัดไป",
      returnBtn: "กลับ",
      returnList: "กลับไปที่รายการ",
      prevArticle: "หน้าถัดไป",
      nextArticle: "หน้าก่อนหน้า",
      noContent: "ไม่มีเนื้อหา",
      backToIndex: "กลับสู่หน้าหลัก",
      more: "เพิ่มเติม",
    },
  },
  yy: {
    title: "กลยุทธ์เก้ารัฐ",
    slogan: "เกมสงครามกลยุทธ์เรียลไทม์",
    preRegister: "ลงทะเบียนล่วงหน้า",
    giftTitle: "การแข่งขันชิงรางวัลลกเอี๋ยง",
    milestoneTitle: "ติดตามรับรางวัล",
    featureTitle: "เข้าสู่เว็บไซต์ทางการ",
    comingSoon: "เร็วๆ นี้",
  },
  foot: {
    Notice: "ข้อควรระวัง",
    privacyPolicy: "นโยบายความเป็นส่วนตัว",
    termsOfService: "ข้อกำหนดสมาชิก",
    EmailText: "E-mail：",
    copy: "คัดลอกสำเร็จ",
    version: "Copyright© 2026 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
  alliance: {
    language_1: "กรุณาเข้าร่วมหรือสร้างพันธมิตรก่อน",
    language_2: "จำนวนครั้งไม่เพียงพอกรุณาทำภารกิจเพื่อรับ",
    language_3: "กรุณาเข้าสู่ระบบก่อน",
    language_4: "โปรดรอติดตาม",
    language_5: "คัดลอกสำเร็จ",
    language_6: "คัดลอกไม่สำเร็จ โปรดลองคัดลอกด้วยตนเอง",
    language_7: "คัดลอกลิงก์สำเร็จ! รีบชวนเพื่อนเข้าร่วมพันธมิตรกันเลย!",
    language_8:
      "กิจกรรมจัดตั้งพันธมิตรล่วงหน้าสิ้นสุดแล้ว ไปที่ [จับรางวัล] > [รางวัลของฉัน] รับรหัสแพ็ก",
    footer: {
      language_1: "Rules",
      language_2: "Privacy Policy",
      language_3: "VIP Terms",
    },
    home: {
      language_1_1: "สวัสดี, [",
      language_1_2: "]",
      language_2: "จำนวนสมาชิกพันธมิตร: ",
      language_3: "คะแนนพันธมิตร: ",
      language_4: "จำนวนพันธมิตรปัจจุบัน: ",
      language_5: "กรอก ID หรือชื่อพันธมิตรเตรียมรบ",
      // language_6: "ID ",
      language_7: "ผู้นำ",
      language_8: "จำนวนสมาชิก",
      language_9: "คำประกาศพันธมิตร",
      language_10: "เข้าสู่ระบบ",
      create: {
        language_1: "กรุณากรอก (ไม่เกิน 30 ตัวอักษร)",
        language_2: "กรุณากรอก (ไม่เกิน 30 ตัวอักษร)",
        language_3: "กรุณากรอก (ไม่เกิน 100 ตัวอักษร) ",
        language_4: "กรุณากรอกลิงก์กลุ่ม",
      },
    },
    luckyDraw: {
      language_1: "จำนวนโอกาสลุ้นรางวัลที่เหลือ: ",
    },
    quests: {
      language_1: " คะแนน",
      language_2: " สิทธิ์ลุ้นรางวัล",
      language_3: "แชร์หน้ากิจกรรมครั้งแรกของวัน",
      language_4: "เชิญเพื่อนเข้าร่วม",
      language_5: "ไปลงทะเบียนล่วงหน้าที่ร้านค้า",
      language_6: "ติดตาม Facebook ทางการ",
      language_7: "เข้าร่วม Discord ทางการ",
    },
    confirmDialog: {
      language_1:
        "แต่ละบัญชีสามารถสร้างหรือเข้าร่วมพันธมิตรได้เพียง 1 ครั้งเท่านั้น เมื่อสร้างหรือเข้าร่วมแล้วจะไม่สามารถยกเลิกได้ ยืนยันหรือไม่?",
    },
    successDialog: {
      language_1: "ยินดีด้วย คุณเข้าร่วมพันธมิตรนี้แล้ว",
      language_2: "สร้างพันธมิตรสำเร็จ",
      language_3:
        "ทำภารกิจพันธมิตรเพื่อรับคะแนนและสิทธิ์ลุ้นรางวัล พร้อมรับรางวัลมากมาย!",
    },
    myRewardsDialog: {
      language_1: " คน",
      language_2: "ป้ายยุติธรรม x",
    },
    preSelectedServerDialog: {
      language_1: "เซิร์ฟเวอร์",
      language_2:
        "กรุณาใช้บัญชี RASTAR GAMES เดียวกับที่ใช้เข้าร่วมกิจกรรมสร้างพันธมิตรล่วงหน้าในการเข้าสู่ระบบเกม หลังจากเปิดให้บริการอย่างเป็นทางการ ให้สร้างตัวละครด้วยบัญชีนี้ภายใน 6 ชั่วโมง คุณจะสามารถเข้าเซิร์ฟเวอร์ที่เลือกได้โดยตรง โดยไม่จำกัดสถานะของเซิร์ฟเวอร์ แต่ละเซิร์ฟเวอร์รองรับการจองล่วงหน้าสำหรับพันธมิตรได้สูงสุด 3 พันธมิตร โดยยึดตามลำดับก่อนหลัง เมื่อสิทธิ์เต็มจะไม่สามารถเลือกได้ ทั้งนี้หัวหน้าพันธมิตรสามารถเปลี่ยนเซิร์ฟเวอร์ที่จองไว้ได้ตลอดก่อนกิจกรรมสร้างพันธมิตรล่วงหน้าสิ้นสุด",
    },
    receivedDialog: {
      language_1:
        "*รางวัลจะมอบในรูปแบบโค้ดแลกรางวัลบนหน้ากิจกรรมนี้หลังเปิดให้บริการอย่างเป็นทางการ โดยต้องเข้าสู่ระบบด้วยบัญชี RASTAR GAMES เพื่อรับรางวัล",
    },
    speedRankingDialog: {
      language_1: "เซิร์ฟเวอร์กิจกรรม: ",
      language_2: "อันดับ",
      language_3: "เซิร์ฟเวอร์",
      language_4: "ชื่อพันธมิตร",
      language_5: "เวลาที่ใช้",
      language_6: "อัปเดตข้อมูลเมื่อ: ",
      language_7: " นาที ",
      language_8: " วินาที",
    },
  },
};
